import { IArea, IEntityBase, IZone } from "../../../../types";

export enum PriorityType {
  Low,
  Medium,
  Important,
  Urgent
}

export enum ProgressType {
  Pending,
  InProgress,
  OnHold,
  Cancelled,
  Completed
}

export interface IDepartment extends IEntityBase {
  departmentID: number | null;
}

export interface IUserBase {
  userID: number;
  userName: string;
  email: string;
}

export interface ITask {
  taskID?: number;
  division: IDivision;
  owner: IUserBase;
  controlPriority: PriorityType;
  priority: PriorityType;
  progress: ProgressType;
  reference: string;
  title: string;
  description: string;
  startDate: string | null;
  dueDate: string | null;
  completeDate: string | null;
  approvedDate: string | null;
  creationDate: string;
  area: IArea | null;
  zone: IZone | null;
  department: IDepartment | null;
  assigned: IUserBase | null;
  extraData: Record<string, any>;
  hasAttachments: boolean;
  sortIndex: number;
}

export interface IDepartmentSchema {
  departmentID: number;
  code: string;
  name: string;
  color: string;
  users: IUserBase [];
}


export interface ITaskAttachment {
  taskAttachmentID?: number;
  taskID: number;
  fileName: string;
  fileSize: number;
  fileType: string;
  data: string;
}


export interface ITaskComment {
  datetime: string;
  priority?: PriorityType;
  progress?: ProgressType;
  comment: string;
  userID: number;
  userName: string;
}

export interface ITaskItem {
  hash: string;
  title: string;
  description: string;
  progress: ProgressType;
  startDate: string | null;
  completeDate: string | null;
  department: IDepartment | null;
  assigned: IUserBase | null;
}

export interface IDivision {
  divisionID: number;
  code: string;
  name: string;
  color: string | null;
  sortIndex: number;
}